import { useEffect, useState } from "react";
import api from "../api/axios";

export default function AddMenu() {
  const [menus, setMenus] = useState([]);

  const [form, setForm] = useState({
    menuId: 0,
    parentId: null,
    menuName: "",
    menuUrl: "",
    icon: "",
    displayOrder: 1,
    isActive: true,
    app_Web: "Web",
    created_By: 1,
    remark: "",
  });

  useEffect(() => {
    loadParentMenu();
  }, []);

  const loadParentMenu = async () => {
    try {
      const res = await api.get("/Menu/GetMenu");

      setMenus(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const saveMenu = async (e) => {
    e.preventDefault();

    try {
      await api.post("/Menu/InsertMenu", form);

      alert("Menu Saved Successfully");

      setForm({
        menuId: 0,
        parentId: "",
        menuName: "",
        menuUrl: "",
        icon: "",
        displayOrder: 1,
        isActive: true,
        app_Web: "Web",
        created_By: 1,
        remark: "",
      });

      loadParentMenu();
    } catch (err) {
      // catch (err) {

      //     console.log(err);

      //     alert("Save Failed");

      // }

      console.log(err.response);
      console.log(err.response.data);
      alert(JSON.stringify(err.response.data));
    }
  };

  return (
    <div className="card shadow">
      <div className="card-header bg-primary text-white">
        <h4>Add Menu</h4>
      </div>

      <div className="card-body">
        <form onSubmit={saveMenu}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label>Parent Menu</label>

              <select
                name="parentId"
                className="form-select"
                value={form.parentId}
                onChange={handleChange}
              >
                <option value="">Root Menu</option>

                {menus
                  .filter((x) => x.parentId == null)
                  .map((x) => (
                    <option key={x.menuId} value={x.menuId}>
                      {x.menuName}
                    </option>
                  ))}
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label>Menu Name</label>

              <input
                type="text"
                name="menuName"
                className="form-control"
                value={form.menuName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Menu URL</label>

              <input
                type="text"
                name="menuUrl"
                className="form-control"
                value={form.menuUrl}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Bootstrap Icon</label>

              <input
                type="text"
                name="icon"
                className="form-control"
                placeholder="bi-house"
                value={form.icon}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Display Order</label>

              <input
                type="number"
                name="displayOrder"
                className="form-control"
                value={form.displayOrder}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6 mt-4">
              <div className="form-check">
                <input
                  type="checkbox"
                  name="isActive"
                  className="form-check-input"
                  checked={form.isActive}
                  onChange={handleChange}
                />

                <label className="form-check-label">Active</label>
              </div>
            </div>

            <div className="col-md-12 mb-3">
              <label>Remark</label>

              <textarea
                name="remark"
                className="form-control"
                rows="3"
                value={form.remark}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-12 text-center">
              <button type="submit" className="btn btn-success">
                Save Menu
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
